module.exports = __webpack_public_path__ + "static/media/EssentialMessage.76f950bb.svg";